import React from 'react';
import { styled } from '@linaria/react';
import ContentWrapper from '@daedalus/atlas/helpers/ContentWrapper';
import { Flex } from '@daedalus/atlas/helpers/Flex';
import { NoStyleLink } from '@daedalus/atlas/helpers/NoStyleLink';
import { Icon, IconName } from '@daedalus/atlas/Icon';
import { Text } from '@daedalus/atlas/Text';
import { Brand } from '@daedalus/core/src/brand/types';
import FormattedMessageWrapper from '@daedalus/core/src/localization/components/FormattedMessage';
interface Props {
  brand: Brand;
  isSingleColumn: boolean;
}
export const FooterSocialSection = ({
  brand,
  isSingleColumn
}: Props) => {
  return <div>
      <Text variant="titleL">
        <FormattedMessageWrapper id="social" defaultMessage="Social" />
      </Text>
      <ContentWrapper paddingTop="s400">
        <Flex.Row gap="s300" justifyContent={isSingleColumn ? 'center' : 'flex-start'}>
          <FooterSocialButton url={brand.socials?.instagramUrl} iconName="Instagram" />
          <FooterSocialButton url={brand.socials?.facebookUrl} iconName="Facebook" />
          <FooterSocialButton url={brand.socials?.linkedinUrl} iconName="Linkedin" />
        </Flex.Row>
      </ContentWrapper>
    </div>;
};
interface FooterSocialButtonProps {
  url?: string;
  iconName: IconName;
}
const FooterSocialButton = ({
  url,
  iconName
}: FooterSocialButtonProps) => {
  if (!url) {
    return null;
  }
  return <SocialLink href={url} target="_blank">
      <Icon name={iconName} size="lg" colorPath={'content.neutral.c950'} />
    </SocialLink>;
};
const _exp = /*#__PURE__*/() => NoStyleLink;
const SocialLink = /*#__PURE__*/styled(_exp())({
  name: "SocialLink",
  class: "s8tw4t5",
  propsAsIs: true
});

require("./SocialSection.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./SocialSection.tsx");